import { FC } from "react";
import { getLiveStockSubTabs } from "helpers/myLivestock";
import { useHasFeature, useLivestockTabs, useStateSpecies } from "hooks";
import { AnimalList as AnimalsListOld } from "components/MyLivestock";
import { AnimalsList } from "animals/AnimalsList";
import { Header, PageHeader, PageContent, Spacer, Tabs } from "components";

export const ArchiveAnimals: FC = () => {
  const { active: speciesActive } = useStateSpecies();
  const LIVESTOCK_TABS = useLivestockTabs();
  const speciesActiveName = speciesActive?.name || "Livestock";
  const title = `My ${speciesActiveName}`;
  const subTitle = `View and manage your ${speciesActiveName.toLowerCase()}`;
  const useServerPaginatedAnimalsList = useHasFeature("SERVER_SIDE_PAGINATION_FOR_ARCHIVE_LIST");

  return (
    <>
      <PageHeader>
        <Header title={title} subTitle={subTitle} />
        <Tabs tabs={LIVESTOCK_TABS} selectedTab={0} />
        <Tabs tabs={getLiveStockSubTabs()} selectedTab={1} grayBackgroundTabs />
      </PageHeader>

      <PageContent>
        <Spacer baselineHeight={1} />
        {useServerPaginatedAnimalsList ? (
          <AnimalsList
            showSelectColumn={false}
            fromPage="livestock"
            showAnimalActionButtons={false}
            showIndividualAnimalActionButtons={false}
            isArchive={true}
          />
        ) : (
          <AnimalsListOld isArchive noResultsText="You have no archived animals" />
        )}
      </PageContent>
    </>
  );
};
